import React from "react";
import Input from "../../../../components/ui/Input";
import { UserWorkExperienceInput } from "../../../../models/employee";
import { DatePicker as CustomDatePicker } from "../../../../components/dateTimePickers";

type WorkExperienceFormProps = {
    workExperienceInput: UserWorkExperienceInput;
    setWorkExperienceInput: (input: UserWorkExperienceInput) => void;
    loading: boolean;
    t: any;
};

const WorkExperienceForm: React.FC<WorkExperienceFormProps> = ({ workExperienceInput, setWorkExperienceInput, loading, t }) => {
    return (
        <div className="flex flex-col gap-2.5">
            <Input
                autoFocus
                label={t("Company Name")}
                type="text"
                value={workExperienceInput.companyName}
                onChange={(e) => setWorkExperienceInput({ ...workExperienceInput, companyName: e.target.value })}
            />
            <Input
                label={t("Job Title")}
                type="text"
                value={workExperienceInput.jobTitle}
                onChange={(e) => setWorkExperienceInput({ ...workExperienceInput, jobTitle: e.target.value })}
            />
            <Input
                label={t("Job Description")}
                type="text"
                value={workExperienceInput.jobDescription}
                onChange={(e) => setWorkExperienceInput({ ...workExperienceInput, jobDescription: e.target.value })}
            />
            {/* <div>
                <Input
                    type="checkbox"
                    checked={workExperienceInput.isCurrentJob}
                    onChange={(e) => setWorkExperienceInput({ ...workExperienceInput, isCurrentJob: e.target.checked })}
                />
                <label>{t("Current Job")}</label>
            </div> */}
            <CustomDatePicker
                label={t("Start Date")}
                value={workExperienceInput.startDate ? (workExperienceInput.startDate) : null}
                onChange={(date) => setWorkExperienceInput({ ...workExperienceInput, startDate: date ?? undefined })}
            />
            <CustomDatePicker
                label={t("End Date")}
                value={workExperienceInput.endDate ? (workExperienceInput.endDate) : null}
                onChange={(date) => setWorkExperienceInput({ ...workExperienceInput, endDate: date ?? undefined })}
            />
            <Input
                label={t("Location")}
                type="text"
                value={workExperienceInput.location}
                onChange={(e) => setWorkExperienceInput({ ...workExperienceInput, location: e.target.value })}
            />
            <Input
                label={t("Manager Name")}
                type="text"
                value={workExperienceInput.managerName}
                onChange={(e) => setWorkExperienceInput({ ...workExperienceInput, managerName: e.target.value })}
            />
            <Input
                label={t("Manager Contact")}
                type="text"
                value={workExperienceInput.managerContact}
                onChange={(e) => setWorkExperienceInput({ ...workExperienceInput, managerContact: e.target.value })}
            />
        </div>
    );
};

export default WorkExperienceForm;
